import { Survey, SurveyAggregatedResult, SurveyAnswerModel, SurveyServerModel } from 'src/data/types/surveys/types';
import { SimpleAnnouncement } from 'src/data/types/base';
import { PagedResults } from 'src/data/types/paging';
import { TrackedUser } from 'src/data/types/tracked-users/types';
import { createController, createControllerEndpoint } from 'src/utils/api';
import { getGlobalProject } from 'src/utils/globals';

const project = getGlobalProject() || { UniqueCode: '' };

export default createController('/api/v2/' + project.UniqueCode + '/surveys', {
    getList: createControllerEndpoint<PagedResults<SurveyServerModel>>('GET', '/'),
    create: createControllerEndpoint<SurveyServerModel>('POST', '/'),
    clone: createControllerEndpoint<SurveyServerModel>('POST', '/{id}/clone'),
    getById: createControllerEndpoint<SurveyServerModel>('GET', '/{id}'),
    save: createControllerEndpoint<SurveyServerModel>('PUT', '/{id}'),
    publish: createControllerEndpoint<void>('PUT', '/{id}/publish'),
    unpublish: createControllerEndpoint<void>('DELETE', '/{id}/publish'),
    delete: createControllerEndpoint<void>('DELETE', '/{id}'),
    restartForUsername: createControllerEndpoint<void>('POST', '/{id}/restart'),

    listAnswers: createControllerEndpoint<PagedResults<SurveyAnswerModel>>('GET', '/{id}/answers'),

    getAggregatedResult: createControllerEndpoint<Array<{ qId: string, data: any }>>('POST', '/{id}/aggregated-results'),

    searchByName: createControllerEndpoint<Array<{ id: string, internalName: string }>>('GET', '/search'),
});